/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * When the form was completed
 * @export
 * @interface CompletedAt1
 */
export interface CompletedAt1 {
}

/**
 * Check if a given object implements the CompletedAt1 interface.
 */
export function instanceOfCompletedAt1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CompletedAt1FromJSON(json: any): CompletedAt1 {
    return CompletedAt1FromJSONTyped(json, false);
}

export function CompletedAt1FromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedAt1 {
    return json;
}

export function CompletedAt1ToJSON(value?: CompletedAt1 | null): any {
    return value;
}

